import { CanDeactivateFn } from '@angular/router';
import { LeitorPageComponent } from '../leitor-page/leitor-page.component';

export const canDeactivateLeitorGuard: CanDeactivateFn<LeitorPageComponent> = (component) => {
  if (component.leituraCompleta) return true;
  return window.confirm(
    'Você ainda não chegou ao fim da prévia.\nTem certeza que quer sair?'
  );
};
